import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AddProgramDetails from "../views/expert-program/AddProgramDetailsView.vue";
import AddAccountBalance from "../views/expert-program/AddAccountBalanceView.vue";
// import AddSubscription from "../views/expert-program/AddSubscriptionView.vue";
import ExpertsDirectory from "../views/expert-program/ExpertsDirectoryView.vue";
import AddIntegration from "../views/expert-program/AddIntegrationView.vue";
import AddSalesforceIntegration from "../views/expert-program/AddSalesforceIntegrationView.vue";
import AddHubspotIntegration from "../views/expert-program/AddHubspotIntegrationView.vue";
import BillingPage from "../views/dashboard/BillingView.vue";
import AccountPage from "../views/dashboard/AccountView.vue";
import TeamPage from "../views/dashboard/TeamView.vue";
import SubscriptionPage from "../views/dashboard/SubscriptionView.vue";
import ExpertPrograms from "../views/dashboard/ExpertProgramsView.vue";
import AnalyticsPage from "../views/dashboard/AnalyticsView.vue";
import SignInLanding from "../views/SignInLandingView.vue";
import BookMeeting from "../views/expert-meeting/BookMeetingView.vue";
import DirectoryTesting from "../views/DirectoryTestingView.vue";
import FronteggSignup from "@/views/frontegg/SignUpView.vue";
import HomeView from "@/views/HomeView.vue";
import CompanyDetailsView from "@/views/AddCompanyDetailsView.vue";
import CallBackView from "@/views/CallbackView.vue";
import ExpertSignup from "@/views/ExpertSignup.vue";
import InviteExperts from "../views/expert-program/InviteExpertsView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/oauth/callback",
    component: CallBackView,
  },
  {
    path: "/company/info",
    name: "AddCompanyDetails",
    component: CompanyDetailsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/signup",
    component: FronteggSignup,
  },
  {
    path: "/invite/company",
    redirect: "/signup",
  },
  {
    path: "/company/analytics",
    name: "AnalyticsPage",
    component: AnalyticsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/expert-program/add-program-details",
    name: "AddProgramDetails",
    component: AddProgramDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/expert-program/add-account-balance",
    name: "AddAccountBalance",
    component: AddAccountBalance,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/company/expert-program/add-subscription",
  //   name: "AddSubscription",
  //   component: AddSubscription,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/experts_booking_system",
    name: "ExpertsDirectory",
    component: ExpertsDirectory,
  },
  {
    path: "/company/expert-program/add-integration",
    name: "AddIntegration",
    component: AddIntegration,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/integration/salesforce",
    name: "AddSalesforceIntegration",
    component: AddSalesforceIntegration,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/integration/hubspot",
    name: "AddHubspotIntegration",
    component: AddHubspotIntegration,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/programs/experts/invite",
    name: "InviteExpertsDirect",
    component: InviteExperts,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/billing-page",
    name: "BillingPage",
    component: BillingPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/billing-page/add",
    name: "BillingPageAdd",
    component: BillingPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/account-page",
    name: "AccountPage",
    component: AccountPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/team-page",
    name: "TeamPage",
    component: TeamPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/subscription-page",
    name: "SubscriptionPage",
    component: SubscriptionPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/programs",
    name: "ExpertPrograms",
    component: ExpertPrograms,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/programs/suggested-experts",
    name: "SuggestedExperts",
    component: ExpertPrograms,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/programs/experts",
    name: "Experts",
    component: ExpertPrograms,
    meta: { requiresAuth: true },
  },
  {
    path: "/company/signin/landing",
    name: "SignInLanding",
    component: SignInLanding,
  },
  {
    path: "/company/expert-meeting/book-meeting",
    name: "BookMeeting",
    component: BookMeeting,
  },
  {
    path: "/directory-testing",
    name: "DirectoryTesting",
    component: DirectoryTesting,
  },
  {
    path: "/expert/signup",
    name: "ExpertSignup",
    component: ExpertSignup,
    meta: { requiresAuth: true },
  },
  {
    path: "/:programSlug/:expertSlug",
    name: "BookMeetingBySlug",
    component: BookMeeting,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
